import * as React from 'react'
import { Button, Paper, TextField, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import { adminLogin } from '../backend'
import { useState } from 'react'
export default function LoginForm({ setAuthenticated }) {
  const [userName, setUserName] = useState('')
  const [password, setPassword] = useState('')

  const handleLogin = () => {
    adminLogin(userName, password)
      .then(() => setAuthenticated(true))
      .catch(() => {
        setAuthenticated(false)
        alert("Erreur d'authentification")
      })
  }

  return (
    <Paper
      elevation={3}
      sx={{
        minHeight: '400px',
        p: 4,
        borderRadius: 10,
        maxWidth: 400,
        mx: 'auto',
        mt: 10
      }}
    >
      <Typography variant='h5' sx={{ mb: 2, fontWeight: 'bold' }}>
        Accès Admin
      </Typography>

      <TextField
        label="Nom d'utilisateur"
        type='input'
        value={userName}
        onChange={(e) => setUserName(e.target.value)}
        fullWidth
        sx={{ mb: 2 }}
      />
      <TextField
        label='Mot de passe'
        type='password'
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        fullWidth
        sx={{ mb: 2 }}
      />
      <Button variant='contained' onClick={handleLogin} fullWidth>
        Se connecter
      </Button>
    </Paper>
  )
}

LoginForm.propTypes = {
  setAuthenticated: PropTypes.func.isRequired
}
